import { IonCardContent, IonContent, IonPage, IonButton } from "@ionic/react";
import React, { useState } from "react";
import Header from "../../../components/Header";

const ContactUs: React.FC = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleBack = () => {
        window.history.back();
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Add your submit logic here (e.g., send to API)
        setName("");
        setEmail("");
        setMessage("");
        alert("Your message has been sent!");
    };

    return (
        <IonPage>
            <Header
                showGreeting={false}
                showPageTitle={true}
                showUserIcon={false}
                pageTitle="Contact Us"
                showBackButton={true}
                onBackButtonClick={handleBack}
            />
            <IonContent className="ion-padding" style={{ "--background": "#F7F5FA" }}>
                <IonCardContent>
                    <h1 style={{ marginBottom: "1rem" }}>Contact Support</h1>
                    <address style={{ marginBottom: "2rem" }}>
                        <span className="text-grey font-semibold">ABM Respiratory Care</span>
                        <br />
                        860 Blue Gentian Road
                        <br />
                        Suite 200
                        <br />
                        Eagan, MN 55121
                        <br />
                        <span className="text-grey font-semibold">Email:</span>{" "}
                        <a href="mailto:Customer.Service@abmrc.com">
                            Customer.Service@abmrc.com
                        </a>
                        <br />
                        <span className="text-grey font-semibold">Phone:</span>{" "}
                        <a href="tel:1-877-226-7201">1-877-226-7201</a>
                    </address>
                    <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
                        <input
                            value={name}
                            onChange={e => setName(e.target.value)}
                            type="text"
                            placeholder="Name"
                            className="custom-input"
                            required
                            disabled={false}
                            maxLength={50}
                            style={{
                                border: "1px solid #ccc",
                                padding: "0 12px",
                                height: "48px",
                            }}
                            autoComplete="off"
                            spellCheck={false}
                            inputMode="text"
                        />
                        <input
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            type="email"
                            placeholder="Email"
                            className="custom-input"
                            required
                            disabled={false}
                            maxLength={100}
                            style={{
                                border: "1px solid #ccc",
                                padding: "0 12px",
                                height: "48px",
                            }}
                            autoComplete="off"
                            spellCheck={false}
                            inputMode="email"
                        />
                        <textarea
                            value={message}
                            onChange={e => setMessage(e.target.value)}
                            placeholder="Message"
                            className="custom-input"
                            required
                            disabled={false}
                            maxLength={1000}
                            style={{
                                border: "1px solid #ccc",
                                padding: "12px",
                                minHeight: "150px",
                                height: "100px",
                                resize: "vertical",
                            }}
                            autoComplete="off"
                            spellCheck={false}
                        />
                        <IonButton className="primary-button" type="submit" expand="block">Send Message</IonButton>
                    </form>
                </IonCardContent>
            </IonContent>
        </IonPage>
    );
};

export default ContactUs;
